// extracted by mini-css-extract-plugin
module.exports = {"failGif":"CredentialsExpiredModal_failGif__126ve"};